
import React, { useEffect, useState }  from "react";
import { useParams } from "react-router-dom";
// components
import Sidebar from "components/Sidebar/Sidebar.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import styled from "styled-components";
import { getWebRTCToken } from "services/webrtc.js";
import { LiveKitRoom, VideoConference } from "@livekit/components-react";
import "@livekit/components-styles";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export const WebRTC = () => {
  const [webRTCToken, setWebRTCToken] = useState();
  const { room_name = "main"} = useParams();

  useEffect(() => { 
    const fetchToken = async () => {
      const webRTCToken = await getWebRTCToken(room_name);
      console.log("WEB RTC TOKEN: ", webRTCToken);
      setWebRTCToken(webRTCToken);
    }

    fetchToken();
  }, [])
  return (
    <>
      <div style={{backgroundColor: "black", margin: "0 auto", width: "100vw", height: "100vh", aspectRatio: "16/9"}}>
        {webRTCToken  ? 
                <LiveKitRoom 
                  token={webRTCToken}
                  serverUrl="wss://webrtc.agentwire.ai"
                  connect={true}
                  audio={true}
                  video={true}
                  data-lk-theme="default"
                >
              

                  <VideoConference/>
                </LiveKitRoom>
                : <div>Loading Token</div>
        }
      </div>
    </>
  );
};

export default WebRTC;
